import { render, staticRenderFns } from "./ClinicReports.vue?vue&type=template&id=67bd275c"
import script from "./ClinicReports.vue?vue&type=script&lang=js"
export * from "./ClinicReports.vue?vue&type=script&lang=js"
import style0 from "./ClinicReports.vue?vue&type=style&index=0&id=67bd275c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports